import Vue from 'vue';
import VueSelectImage from 'vue-select-image';

require('vue-select-image/dist/vue-select-image.css');

Vue.use(VueSelectImage);
